import { makeStyles } from '@surveycake/rc';

const textField = `
	width: 100%;
	font-size: 16px;
	line-height: 1.6;
	border: none;
	border-radius: 0;
	padding: 5px;
	outline: none;
	box-shadow: none;
	box-sizing: border-box;
`;

export const useSinglelineStyles = makeStyles([
  [
    'textField',
    theme => `
		${textField}
		border-bottom: 1px solid ${theme.survey.option.default.border.color};

		&:focus {
			border-bottom: 1px solid ${theme.color.semantic.warning};
		}
	`
  ]
]);

export const useMultilineStyles = makeStyles([
  [
    'textField',
    theme => `
		${textField}
		border: 1px solid ${theme.survey.option.default.border.color};
		border-radius: 3px;
		resize: none;

		&:focus {
			border: 1px solid ${theme.color.semantic.warning};
		}
	`
  ]
]);
